<template>
	<div class="new-type-form-container"
		:style="`border-color:${$appColors.gray}`"
	>
		<h2 :style="`color:${$appColors.info}`">Nuevo Tipo de Nivel</h2>
		<form>
			<label class="name-input" :style="`color:${$appColors.info}`">
				Nombre
				<input
					class="new-survey-input" 
					placeholder="Nombre"
					v-model="newType.name"
				/>
			</label>
			<label class="level-input">
				Nivel
				<input
					class="new-survey-input" 
					v-model="newType.level"
				/>
			</label>
			<app-button
				class="btn-tool"
				icon="add"
				:style="`background-color:${$appColors.primary}`"
			/>
		</form>
	</div>
</template>
<script>
import appButton from '@/components/shared/app-button';

function data() {
	return {
		newType: {
			name: '',
			level: '',
		},
	};
}

export default {
	name: 'new-type-form',
	components: {
		appButton,
	},
	data,
};
</script>
<style lang="scss" scoped>
.new-type-form-container {
	background-color: white;
	border-radius: 4px;
	border: solid 1px;
  	box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.02);
	padding: 24px 16px;

	h2 {
		font-size: size(xlarge);
		margin-bottom: 20px;
	}

	form {
		align-items: flex-end;
		display: flex;
		justify-content: flex-start;

		label {
			margin-right: 20px;
		}

		.name-input {
			flex-basis: 45%;
		}

		.level-input {
			flex-basis: 10%;
		}

		.btn-tool {
			border-radius: 4px;
			color: white;
			font-family: font(bold);
			height: 34px;
			padding: 5px 10px;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/configuration/types/new-type-form.vue